module.exports = __webpack_public_path__ + "static/media/varal-tradicional-parede-manivela.34c1e84a.jpg";